import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { MyPublicationsContainerProps } from "../../../interfaces/containers";
import EntryPoint from "../../../pages/Profile/MyPublications/EntryPoint";
import{ filterMyPublications, cleanFilterMyPublications, cleanDataFiltersMyPublications, setSearchMyPublications, setPublicationForNews } from "../../../actions/myPublications";
import { getMyPublicationsRequest} from "../../../actions/profile";
import { setDataSheet } from "../../../actions/salePost";
import { getPublicationsReport } from "../../../actions/dashboard";


function mapStateToProps(state: MyPublicationsContainerProps) {
    return{
        user: state.auth.user,
        myPublications: state.profile.myPublications,
        pause: state.publication.pause,
        dealership: state.auth.concessionary,
        fetchingReport: state.profile.fetchingReport
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getMyPublicationsRequest,
        filterMyPublications,
        cleanFilterMyPublications,
        cleanDataFiltersMyPublications,
        setSearchMyPublications,
        setPublicationForNews,
        setDataSheet,
        getPublicationsReport
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(EntryPoint);